// extracted by mini-css-extract-plugin
export default {"selectWrapper":"RoleSelect_selectWrapper__WOnH7"};